import { StockConfig } from 'types/types';
import {
  incrementQuantity,
  maxQuantity,
  minQuantity,
} from '../../util/products';
import Select from 'components/form/select';
import { SelectProps } from 'components/form/select/component';
import { ChangeEvent } from 'react';

const QuantitySelect = ({
  onChange,
  qtyLeft,
  quantity,
  selectProps,
  stockConfig,
}: {
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  qtyLeft?: number | null;
  quantity: number;
  selectProps?: SelectProps;
  stockConfig: StockConfig;
}) => {
  const increment = incrementQuantity(stockConfig);
  const min = minQuantity(stockConfig);
  const max = Math.max(
    qtyLeft
      ? Math.min(qtyLeft, maxQuantity(stockConfig))
      : maxQuantity(stockConfig),
    quantity
  );

  const quantityOptions: {
    label: string;
    value: string | number;
  }[] = [];
  for (let x = min; x <= max; x += increment) {
    quantityOptions.push({
      label: x.toString(),
      value: x,
    });
  }

  return (
    <Select
      id="product-quantity-select"
      value={quantity}
      onChange={onChange}
      {...selectProps}
    >
      {quantityOptions.map(quantityOption => {
        return (
          <option key={quantityOption.label} value={quantityOption.value}>
            {quantityOption.label}
          </option>
        );
      })}
    </Select>
  );
};

export default QuantitySelect;
